function parseBoolean(stringBoolean) {
    if (typeof stringBoolean !== "string") {
        throw new TypeError("Input must be a string");
    }

    const test = stringBoolean.trim().toLowerCase();

    if (test === "true") {
        return true;
    }

    if (test === "false") {
        return false;
    }
}

export { parseBoolean };
